import { Button, Col, DatePicker, Form, Input, Row, Select, Spin } from 'antd';
import React, { useEffect } from 'react';
import { DAY_FORMAT, DATE_BACKEND_FORMAT } from '../../../constants';
import { ReactSVG } from 'react-svg';

const RoutePlanForm = ({ isFetching, onCancel, handleFinish, routePlan }) => {
  const [form] = Form.useForm();

  const onFinishForm = (values) => {
    // convert deliveryDate to day string without time
    values.deliveryDate = values.deliveryDate.format(DATE_BACKEND_FORMAT);
    handleFinish && handleFinish(values);
  };

  useEffect(() => {
    if (routePlan) {
      form.setFieldsValue({ ...routePlan, deliveryDate: undefined });
    } else {
      form.resetFields();
    }
  }, [routePlan]);

  return (
    <Spin spinning={isFetching}>
      <div className="RoutePlanForm">
        <Form
          form={form}
          scrollToFirstError
          layout="vertical"
          requiredMark={false}
          colon={false}
          className="FormContent"
          onFinish={onFinishForm}
          initialValues={{}}
        >
          <Row gutter={[20, 20]}>
            <Col span={24}>
              <Form.Item label="Route Name" name="name" rules={[{ required: true, message: 'Required' }]}>
                <Input placeholder="Name" size="large" />
              </Form.Item>
            </Col>
            {!routePlan && (
              <Col span={24}>
                <Form.Item name="deliveryDate" label="Delivery Date" rules={[{ required: true, message: 'Required' }]}>
                  <DatePicker size="large" format={DAY_FORMAT} />
                </Form.Item>
              </Col>
            )}
            <Col span={24}>
              <Form.Item label="Region " name="region" rules={[{ required: true, message: 'Required' }]}>
                <Select
                  options={[
                    { label: 'Amsterdam', value: 'Amsterdam' },
                    { label: 'Den Haag', value: 'Den Haag' },
                    { label: 'Rotterdam', value: 'Rotterdam' },
                    { label: 'Utrecht', value: 'Utrecht' },
                    { label: 'Maastricht', value: 'Maastricht' },
                  ]}
                />
              </Form.Item>
            </Col>
          </Row>
          <div className="FormFooter">
            <Button className="ButtonCancel" onClick={onCancel}>
              Cancel
            </Button>
            <Button className="CreateButton ButtonPrimary" type="primary" htmlType="submit">
              {routePlan ? 'Update' : 'Create'}
              <ReactSVG className="icon" src="/icons/done.svg" />
            </Button>
          </div>
        </Form>
      </div>
    </Spin>
  );
};

export default RoutePlanForm;
